"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M2 4h15v2H2zm13 13h2v-3h1v-2l-1-5H2l-1 5v2h1v6h9v-6h4zm-6 1H4v-4h5zm-5.96-6 .6-3h11.72l.6 3z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M23 18h-3v-3h-2v3h-3v2h3v3h2v-3h3z"
}, "1")], 'AddBusinessOutlined');